import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import SettingsIcon from '@mui/icons-material/Settings'
import {  Row, Span, SuccessModal } from 'components'
import { Link } from 'components/Link/Link'
import { useAuth, useToggle, useEnvironment, useModal } from 'hooks'
import { COLORS, SPACING } from 'utils'
import jwt from 'jsonwebtoken'
import { ActionsContainer, HeaderMenu } from './Header.styles'
import { ProfileModal } from './ProfileModal/ProfileModal'
import { UserServices } from 'services/Supplier/Users'

export const Header = () => {
  const [openModal, handleModal] = useToggle()
  const [showModalOpen,toggleModal] = useToggle()
  const { showModal } = useModal()
  const { isHomolog, environment, allowLogger } = useEnvironment()
  const { user, allDatadescripted, logout } = useAuth()
  const tkn = localStorage.getItem('csn-tk')



  const handleDescript = (data: any) =>
    !data ? null : JSON.parse(window.atob(data));

  const handlelogout = () => {
    const tokenDescrited = jwt.decode(tkn)

    const userId = handleDescript(tokenDescrited?.Usuario)
    
    const logOutUser = {
      idUsuario: userId.IdUsuario

    };

    toggleModal()
    
    
    UserServices().logout(logOutUser)
    

  logout()
  }

  return (
    <>
      <HeaderMenu position="fixed">
        <Row alignItems="center" justifyContent="flex-end">
          <Span text="Bem-vindo(a)," color={COLORS.black} />
          <Span
            text={user?.NmUsuario}
            marginLeft={SPACING.spacing5}
            fontWeight="bold"
            marginRight={SPACING.spacing50}
            color={COLORS.black}
          />
          <ActionsContainer>
            <Link onClick={handleModal}>
              <SettingsIcon htmlColor={COLORS.black} />
            </Link>
            {!!showModal && (
              <SuccessModal
                type="alert"
                titleModal="Atenção"
                message="Tem certeza que deseja sair?"
                open={showModalOpen}
                txtButtonCancel="Voltar"
                txtButtonConfirm="Sair"
                handleCancel={toggleModal}
                handleConfirm={handlelogout}
              />
            )}

            {/* {allDatadescripted?.Perfil !== 'Csn' || allowLogger ? ( */}
            <Link onClick={toggleModal}>
              <ExitToAppIcon htmlColor={COLORS.black} />
            </Link>
            {/* ) : null} */}
          </ActionsContainer>
        </Row>
        {!isHomolog && <Span text={environment.toUpperCase()} />}
      </HeaderMenu>
      {!!openModal && (
        <ProfileModal open={openModal} handleClose={handleModal} />
      )}
    </>
  )
}
